import { DateTime } from "luxon";
import { FunctionComponent, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Employee, Session } from "../../services/EventService";
import SpeakerElement from "../speaker/Speaker";
import EventAgendaDetailModal from "./EventAgendaDetailModal";

interface EventAgendaItemProps {
    session: any;
    className: string;
}

const EventAgendaItem: FunctionComponent<EventAgendaItemProps> = (props) => {
    const { session, className } = props;

    const [showDetail, setShowDetail] = useState(false);

    const sessionSpeaker = (session: Session) => {
        return session.speaker?.map((s: Employee, i: number) => s ? (
            <SpeakerElement key={i} speaker={s} agendaModalVisible={showDetail}></SpeakerElement>
        ) : null);
    }

    return (
        <>
            <EventAgendaDetailModal show={showDetail} setShowDetail={setShowDetail} session={session} />
            <div className={`rounded-2 p-3 mb-4 event__agenda-item ${className} h-100 position-relative`} onClick={() => (session.description && session.description) !== '' ? setShowDetail(true) : false}>
                <Row>
                    <Col>
                        <small className="event__agenda-item-meta">
                            <strong>{DateTime.fromISO(session.start).toFormat('HH:mm')} - {DateTime.fromISO(session.end).toFormat('HH:mm')}</strong>
                            {session.location && session.location !== '' && ` | ${session.location}`}
                            {session.session_type.title && session.session_type.title !== '' && ` | ${session.session_type.title}`}
                        </small>
                    </Col>
                </Row>
                <Row onClick={(e) => e.stopPropagation()}>
                    <Col className="d-flex justify-content-center gap-3 event__agenda-item-speaker">
                        {sessionSpeaker(session)}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h3 className="event__agenda-item-title">{session.title}</h3>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default EventAgendaItem;